import { render, staticRenderFns } from "./scope2.vue?vue&type=template&id=087b619b&scoped=true"
import script from "./scope2.vue?vue&type=script&lang=js"
export * from "./scope2.vue?vue&type=script&lang=js"
import style0 from "./scope2.vue?vue&type=style&index=0&id=087b619b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087b619b",
  null
  
)

export default component.exports